module.exports = __webpack_public_path__ + "img/vegetable-radishes-190x100.90e7218d.jpg";